// extracted by mini-css-extract-plugin
module.exports = {"terms":"index-module--terms--2m6Wz","content":"index-module--content--1_l__"};